import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import './CalendarPage.scss'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { CalendarComponent, PageLoadingSpinner } from 'ui_kit_qmd'
import { setError, setIsAppointmentPopUpInfoVisible, updateScheduleView } from '../../store/calendar/CalendarActions'
import { getAppointmentInfo, getCurrentSchedule, getVisitTypeGroups } from '../../store/calendar/CalendarThunk'
import AvailabilityPopUp from './AvailabilityPopUp/AvailabilityPopUp'
import DetailsView from './DetailsView/DetailsView'
import { getTabId, parseTimeZone } from '../../utils/common'
import SelectModePopUp from './SelectModePopUp/SelectModePopUp'
import { CalendarPageListener } from './CalendarPageListener'
import { LOCAL_STORAGE_STATE_TO_CALENDAR } from '../../utils/constants'
import { useSelector } from 'store/hooks/useSelector'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'
import { PageLayout } from 'components/page-layouts/PageLayout'

const CalendarPage = memo(() => {
  const tabId = getTabId()
  const dispatch = useDispatch()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.calendarPageReducer.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const schedule = useSelector((state) => state.calendarPageReducer?.[tabId]?.schedule || [])
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const pnbSchedule = useSelector((state) => state.calendarPageReducer?.[tabId]?.pnbSchedule || [])
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visitsSchedule = useSelector((state) => state.calendarPageReducer?.[tabId]?.visitsSchedule || [])
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const updateScheduleRange = useSelector((state) => state.calendarPageReducer.updateScheduleRange)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.calendarPageReducer.error)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const isAppointmentPopUpInfoVisible = useSelector((state) => state.calendarPageReducer.isAppointmentPopUpInfoVisible)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const AppointmentInfo = useSelector((state) => state.calendarPageReducer.AppointmentInfo)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const visitTypeGroups = useSelector((state) => state.calendarPageReducer.visitTypeGroups)

  const [showAvailabilityView, setShowAvailabilityView] = useState(false)
  const [showEditPopUpView, setShowEditPopUpView] = useState(null)

  const [showPNBView, setShowPNBView] = useState(false)
  const [clickedStartDateTime, setClickedStartDateTime] = useState({})
  const [clickedEndDateTime, setClickedEndDateTime] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [detailsInfo, setDetailsInfo] = useState({})
  const [dateRange, setDateRange] = useState({})
  const [isShowSelectRecursionChangeModePopUp, setIsShowSelectRecursionChangeModePopUp] = useState(false)
  const [isSelectModePopUp, setIsSelectModePopUp] = useState(false)
  const [isRecurrenceOn, toggleIsRecurrenceOn] = useState(false)
  const [mounted, setMounted] = useState(false)
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const timeZone = parseTimeZone(profile.TimeZone)
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [calendarKey, setCalendarKey] = useState(Math.random())
  const [isNeedToResetRecurrence, setIsNeedToResetRecurrence] = useState(false)
  const [newRecurrenceValueFromUIKit, setNewRecurrenceValueFromUIKit] = useState(null)

  const daysOfWeekRef = useRef(null)

  const startDateTimeChange = useRef(false)
  const endDateTimeChange = useRef(false)

  const { state: locationState } = useLocation()
  // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
  const state = locationState ?? JSON.parse(safeLocalStorage.get(LOCAL_STORAGE_STATE_TO_CALENDAR))

  const getAppointmentInfoById = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (appointmentId) => {
      dispatch(getAppointmentInfo(appointmentId))
    },
    [dispatch],
  )
  useEffect(() => {
    moment.tz.setDefault(Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone)
    return () => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      moment.tz.setDefault(parseTimeZone(profile.TimeZone))
    }
  }, [])

  useEffect(() => {
    if (mounted) {
      if (updateScheduleRange) {
        if (
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          (moment(updateScheduleRange.from).isSameOrAfter(moment(dateRange.from)) &&
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            moment(updateScheduleRange.from).isSameOrBefore(moment(dateRange.to))) ||
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          (moment(updateScheduleRange.to).isSameOrAfter(moment(dateRange.from)) &&
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            moment(updateScheduleRange.to).isSameOrBefore(moment(dateRange.to)))
        ) {
          dispatch(
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            getCurrentSchedule({
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              fromDateTime: dateRange.from,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              toDateTime: dateRange.to,
              shouldShowLoading: false,
              tabId,
            }),
          )
        }
      } else if (isAppointmentPopUpInfoVisible) {
        let updateAppointment = true
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        visitsSchedule.forEach((visit) => {
          if (visit.VisitId === AppointmentInfo.VisitId) updateAppointment = false
        })
        if (updateAppointment) {
          dispatch(getAppointmentInfo(AppointmentInfo.VisitId, false))
        }
      }
    } else {
      setMounted(true)
    }
  }, [updateScheduleRange])

  useEffect(() => {
    if (newRecurrenceValueFromUIKit !== null && isNeedToResetRecurrence) {
      toggleIsRecurrenceOn(newRecurrenceValueFromUIKit)
      setIsNeedToResetRecurrence(false)
      setNewRecurrenceValueFromUIKit(null)
    }
  }, [newRecurrenceValueFromUIKit, isNeedToResetRecurrence])

  useEffect(() => {
    window.onpopstate = null
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getVisitTypeGroups())
  }, [])

  useEffect(() => {
    if (state?.visitId) {
      getAppointmentInfoById(state.visitId)
      safeLocalStorage.remove(LOCAL_STORAGE_STATE_TO_CALENDAR)
    }
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setStartDateHandler = (isRecursiveEvent, isRecursionOn, newStartOrEndDateObj, type) => {
    // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
    const firstStartTime = showEditPopUpView.OccurrenceStartTime
    // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
    const firstEndTime = showEditPopUpView.OccurrenceEndTime

    if (type === 'startTime') {
      startDateTimeChange.current = !(JSON.stringify(firstStartTime) === JSON.stringify(newStartOrEndDateObj))
    } else {
      endDateTimeChange.current = !(JSON.stringify(firstEndTime) === JSON.stringify(newStartOrEndDateObj))
    }
    if (isRecursiveEvent && isRecursionOn && (startDateTimeChange.current || endDateTimeChange.current)) {
      setIsShowSelectRecursionChangeModePopUp(true)
    } else {
      setIsShowSelectRecursionChangeModePopUp(false)
    }
  }

  const getScheduleByFromToCondition = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (from, to) => {
      setDateRange({ from, to })
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getCurrentSchedule({ fromDateTime: from, toDateTime: to, tabId }))
    },
    [dispatch],
  )
  const refreshSchedule = useCallback(() => {
    dispatch(
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      getCurrentSchedule({
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        fromDateTime: dateRange.from,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        toDateTime: dateRange.to,
        tabId,
      }),
    )
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  }, [dateRange.from, dateRange.to, dispatch, tabId])

  const updateSchedule = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (from, to, payload) => {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (from === dateRange.from && to === dateRange.to) {
        dispatch(updateScheduleView(payload, tabId))
        setShowDetails(false)
      }
    },
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    [dateRange.from, dateRange.to, dispatch, tabId],
  )

  const clearReducerError = useCallback(() => {
    dispatch(setError())
  }, [dispatch])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setToggelIsRecurenceOn = (value) => {
    setNewRecurrenceValueFromUIKit(value)
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getSheduleFromTo = (from, to) => {
    getScheduleByFromToCondition(from, to)
  }

  return (
    <PageLayout>
      {loading ?
        <PageLoadingSpinner />
      : null}

      <div className='calendarPageBodyContainer'>
        <CalendarPageListener
          refreshSchedule={refreshSchedule}
          updateSchedule={updateSchedule}
          setShowEditPopUpView={setShowEditPopUpView}
          setShowPNBView={setShowPNBView}
          setShowAvailabilityView={setShowAvailabilityView}
          setIsNeedToResetRecurrence={setIsNeedToResetRecurrence}
        />
        {isSelectModePopUp ?
          <SelectModePopUp
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            isRecurrenceOn
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            startOccurrenceDate={showEditPopUpView.OccurrenceStartTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            endOccurrenceDate={showEditPopUpView.OccurrenceEndTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            repeatEndDate={showEditPopUpView.EndDateTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            occurrenceId={showEditPopUpView.itemId}
            setIsSelectModePopUp={setIsSelectModePopUp}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            scheduleId={showEditPopUpView.scheduleId}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            viewType={showEditPopUpView.type}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            recurrenceEndDateTime={showEditPopUpView.EndDateTime}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            occurrenceOrder={showEditPopUpView.scheduleOrder}
            daysOfWeekRef={daysOfWeekRef}
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            visitTypeGroupId={showEditPopUpView.visitTypeGroupId}
          />
        : null}
        {showAvailabilityView ?
          // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
          <AvailabilityPopUp
            startDate={clickedStartDateTime}
            endDate={clickedEndDateTime}
            isRecurrenceOn={isRecurrenceOn}
            toggleIsRecurrenceOn={toggleIsRecurrenceOn}
            closePopUpCallback={setShowAvailabilityView}
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            setClickedStartDateTime={setClickedStartDateTime}
            setClickedEndDateTime={setClickedEndDateTime}
            calendarTimeZone={timeZone}
            viewType='availability'
            daysOfWeekRef={daysOfWeekRef}
            visitTypeGroups={visitTypeGroups}
          />
        : null}
        {showEditPopUpView ?
          <AvailabilityPopUp
            startDate={clickedStartDateTime}
            endDate={clickedEndDateTime}
            closePopUpCallback={setShowEditPopUpView}
            isRecurrenceOn={isRecurrenceOn}
            toggleIsRecurrenceOn={toggleIsRecurrenceOn}
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            setClickedStartDateTime={setClickedStartDateTime}
            setIsSelectModePopUp={setIsSelectModePopUp}
            isShowSelectRecursionChangeModePopUp={isShowSelectRecursionChangeModePopUp}
            setStartDateHandler={setStartDateHandler}
            setClickedEndDateTime={setClickedEndDateTime}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            viewType={showEditPopUpView.type.includes('availability') ? 'availability' : showEditPopUpView.type}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            isRecursive={showEditPopUpView.isRecursive}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            recurrenceEndDateTime={showEditPopUpView.EndDateTime}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            recurrenceRecurringType={showEditPopUpView.RecurringType}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            occurrenceId={showEditPopUpView.itemId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            repeatDays={showEditPopUpView.RepeatDays}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            scheduleId={showEditPopUpView.scheduleId}
            isEditMode
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            scheduleOrder={showEditPopUpView.scheduleOrder}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            occurrenceOrder={showEditPopUpView.scheduleOrder}
            calendarTimeZone={timeZone}
            daysOfWeekRef={daysOfWeekRef}
            visitTypeGroups={visitTypeGroups}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            visitTypeGroupId={showEditPopUpView.visitTypeGroupId}
            setShowEditPopUpView={setShowEditPopUpView}
          />
        : null}
        {showPNBView ?
          // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
          <AvailabilityPopUp
            startDate={clickedStartDateTime}
            endDate={clickedEndDateTime}
            isRecurrenceOn={isRecurrenceOn}
            toggleIsRecurrenceOn={toggleIsRecurrenceOn}
            closePopUpCallback={setShowPNBView}
            clickedStartDateTime={clickedStartDateTime}
            clickedEndDateTime={clickedEndDateTime}
            setClickedStartDateTime={setClickedStartDateTime}
            setClickedEndDateTime={setClickedEndDateTime}
            calendarTimeZone={timeZone}
            viewType='PNB'
            visitTypeGroups={visitTypeGroups}
          />
        : null}
        {showDetails ?
          // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
          <DetailsView
            detailsInfo={detailsInfo}
            customTimeZone={timeZone}
            setShowDetails={setShowDetails}
            setClickedStartDateTime={setClickedStartDateTime}
            setClickedEndDateTime={setClickedEndDateTime}
            setShowEditAvailabilityView={setShowEditPopUpView}
            visitTypeGroups={visitTypeGroups}
          />
        : null}
        {isAppointmentPopUpInfoVisible ?
          // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
          <DetailsView
            detailsInfo={AppointmentInfo}
            customTimeZone={timeZone}
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            setShowDetails={(newState) => {
              dispatch(setIsAppointmentPopUpInfoVisible(newState))
            }}
            ViewType='appointment'
            visitTypeGroups={visitTypeGroups}
          />
        : null}
        <CalendarComponent
          key={calendarKey}
          setShowPNBView={setShowPNBView}
          setShowAvailabilityView={setShowAvailabilityView}
          visitsSchedule={visitsSchedule}
          schedule={schedule}
          pnbSchedule={pnbSchedule}
          loading={loading}
          setClickedStartDateTime={setClickedStartDateTime}
          setClickedEndDateTime={setClickedEndDateTime}
          getScheduleByFromToCondition={getSheduleFromTo}
          toggleIsRecurrenceOn={setToggelIsRecurenceOn}
          setDetailsInfo={setDetailsInfo}
          setShowDetails={setShowDetails}
          getAppointmentInfoById={getAppointmentInfoById}
          error={error}
          clearReducerError={clearReducerError}
          customTimeZone={timeZone}
          viewType='week'
        />
      </div>
    </PageLayout>
  )
})

export default CalendarPage
